import { Injectable } from '@angular/core';
import { SetFilterValues } from 'ag-grid-community';
import { SimpleTextFilterValue } from '../../grid/types/filter.types';

@Injectable()
export class SetFilterService {
  public states: SetFilterValues = [];
  public taxStatus: SimpleTextFilterValue = {};
  public type: SimpleTextFilterValue = {};
  public pricingStatuses: SimpleTextFilterValue = {};
  public sectors: SetFilterValues = [];
  public purpose: SetFilterValues = [];
  public esgCertification: any = {};
  public bidSubmitted: SimpleTextFilterValue = {};
}
